import { Loader } from 'google-maps';

class Kaart {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-map="scope"]',
			map: '[data-map="map"]',
			info: '[data-map="info"]',
			address: '[data-map="address"]',
			link: '[data-map="link"]'
		}, config);

		this.$scope = $(this.config.scope);
		this.google_api_key = this.$scope.eq(0).data('key');
		this.google = null;

		if (this.$scope.length > 0 && this.google_api_key) {
			this.init();
		}
	}

	async init() {
		try {
			// Load Google Maps once
			const loader = new Loader(this.google_api_key, {
				libraries: ['places', 'geocoding']
			});

			this.google = await loader.load();

			// Process each map scope
			this.$scope.each((index, element) => {
				this.processMapElement(element);
			});

		} catch (error) {
			console.error('Error loading Google Maps:', error);
		}
	}

	processMapElement(element) {
		const $element = $(element);
		const placeId = $element.data('place-id');
		const address = $element.data('address');
		const $mapContainer = $element.find(this.config.map);

		if ($mapContainer.length > 0) {
			if (placeId) {
				// Primary: Use Place ID
				this.getPlaceAndCreateMap(placeId, $mapContainer);
			} else if (address) {
				// Fallback: Use address
				this.geocodeAndCreateMap(address, $mapContainer);
			}
		}
	}

	getPlaceAndCreateMap(placeId, $mapContainer) {
		const service = new this.google.maps.places.PlacesService(document.createElement('div'));

		service.getDetails({ placeId: placeId, fields: ['geometry', 'name', 'formatted_address', 'url'] }, (place, status) => {
			if (status === 'OK') {
				const location = place.geometry.location;
				const address = place.formatted_address;
				const url = place.url;

				this.createMap($mapContainer, location, address, url);
			} else {
				console.error('Place ID lookup failed:', status);
			}
		});
	}

	geocodeAndCreateMap(address, $mapContainer) {
		const geocoder = new this.google.maps.Geocoder();

		geocoder.geocode({ address: address }, (results, status) => {
			if (status === 'OK') {
				const location = results[0].geometry.location;
				const place_id = results[0].place_id;
				const address = results[0].formatted_address;
				const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}&query_place_id=${place_id}`;

				this.createMap($mapContainer, location, address, url);
			} else {
				console.error('Geocoding failed for:', address, status);
			}
		});
	}

	#markerIcon(color = '#82a6d0') {
		const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="29.303" height="42.324" viewBox="0 0 29.303 42.324"><g transform="translate(-7.875 -3.375)"><path d="M22.526,3.375c-8.089,0-14.651,6.246-14.651,13.939,0,8.852,9.768,22.88,13.354,27.725a1.6,1.6,0,0,0,2.595,0C27.41,40.2,37.178,26.173,37.178,17.314,37.178,9.621,30.615,3.375,22.526,3.375Z" fill="${color}"/><path d="M24.393,15.009a4.884,4.884,0,1,1-4.884-4.884A4.884,4.884,0,0,1,24.393,15.009Z" transform="translate(3.018 3.018)" fill="#fff"/></g></svg>`;

		return {
			url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
			scaledSize: new this.google.maps.Size(29.303, 42.324),
			anchor: new this.google.maps.Point(14.652, 42.324),
		};
	}

	#formatAddress(address) {
		return address
			.split(',')
			.map(part => part.trim())
			.filter(Boolean)
			.slice(0, -1)
			.join('<br>')
	}

	createMap($mapContainer, location, address, url) {
		const map = new this.google.maps.Map($mapContainer.get(0), {
			center: location,
			zoom: 10,
			disableDefaultUI: true,
			zoomControl: false,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			styles: [
				{
					featureType: "poi.attraction",
					stylers: [{ visibility: "off" }]
				},
				{
					featureType: "poi.business",
					stylers: [{ visibility: "off" }]
				},
				{
					featureType: "poi.government",
					stylers: [{ visibility: "off" }]
				},
				{
					featureType: "poi.park",
					stylers: [{ visibility: "off" }]
				},
				{
					featureType: "poi.place_of_worship",
					stylers: [{ visibility: "off" }]
				},
				{
					featureType: "poi.school",
					stylers: [{ visibility: "off" }]
				},
				{
					featureType: "poi.sports_complex",
					stylers: [{ visibility: "off" }]
				},
				{
					featureType: "transit",
					stylers: [{ visibility: "off" }]
				},
				{
					stylers: [{saturation: -100}]
				}
			]
		});

		// Get custom info window content from data attribute
		const $info = $mapContainer.closest(this.config.scope).find(this.config.info);
		const $address = $info.find(this.config.address);
		const $link = $info.find(this.config.link);

		// Fill in the resolved address before reading the template
		if ($address.length > 0 && !$address.text().trim() && address) {
			$address.html(this.#formatAddress(address));
		}

		if ($link.length > 0) {
			url ? $link.attr('href', url) : $link.remove();
		}

		const infoContent = $info.html();

		// Create info window
		const infoWindow = new this.google.maps.InfoWindow({
			content: `<div style="padding: 10px; font-family: Arial, sans-serif;">${infoContent}</div>`
		});

		// Add marker
		const marker = new this.google.maps.Marker({
			map: map,
			position: location,
			title: address,
			icon: this.#markerIcon(),
			anchorPoint: new this.google.maps.Point(0, -42.324),
		});

		infoWindow.open(map, marker);

		// Open info window on marker click
		marker.addListener('click', () => {
			infoWindow.open(map, marker);
		});
	}
}

export default new Kaart;
